export default "/assets/images/chart-sm-05.svg?59f219d60c9ac7aca4d16d09b7259ff2";